/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Description_CsInputs */

const cs_form_description_cs = /** @type {(inputs: Form_Description_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popis (CS)`)
};

const en_form_description_cs = /** @type {(inputs: Form_Description_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description (CS)`)
};

/**
* | output |
* | --- |
* | "Description (CS)" |
*
* @param {Form_Description_CsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_description_cs = /** @type {((inputs?: Form_Description_CsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Description_CsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_description_cs(inputs)
	return cs_form_description_cs(inputs)
});